import { forwardRef } from 'react'
import { useTheme, styled, SxProps, Theme } from '@mui/material'

// const BAR_RADIUS = 2
// const BAR_WIDTH = 2

// NOTE: Check performance. use canvas if that's more performant
export const Surfer = forwardRef(function SurferComponent(
  {
    wave,
    seekValue,
    sx,
    variant = 'message',
  }: {
    wave: number[]
    seekValue: number
    sx?: SxProps
    variant?: 'message' | 'preview'
  },
  ref,
) {
  // const canvasRef = useRef(null)

  // useEffect(() => {
  //   const canvas = canvasRef.current
  //   const ctx = canvas.getContext('2d')
  //
  //   ctx.clearRect(0, 0, canvas.width, canvas.height)
  //   const sampleCount = wave.length
  //
  //   wave.forEach((bar, index) => {
  //     const height = (bar / 128) * canvas.height
  //
  //     const x = (index / sampleCount) * canvas.width
  //     const y = canvas.height / 2 - height / 2
  //
  //     const fillStyle =
  //       index / sampleCount < seekValue / 100 ? '#55A6FF' : '#CCCCCC'
  //
  //     ctx.beginPath()
  //     ctx.moveTo(x + BAR_RADIUS, y)
  //     ctx.lineTo(x + BAR_WIDTH - BAR_RADIUS, y)
  //     ctx.arcTo(x + BAR_WIDTH, y, x + BAR_WIDTH, y + BAR_RADIUS, BAR_RADIUS)
  //     ctx.lineTo(x + BAR_WIDTH, y + height - BAR_RADIUS)
  //     ctx.arcTo(
  //       x + BAR_WIDTH,
  //       y + height,
  //       x + BAR_WIDTH - BAR_RADIUS,
  //       y + height,
  //       BAR_RADIUS,
  //     )
  //     ctx.lineTo(x + BAR_RADIUS, y + height)
  //     ctx.arcTo(x, y + height, x, y + height - BAR_RADIUS, BAR_RADIUS)
  //     ctx.lineTo(x, y + BAR_RADIUS)
  //     ctx.arcTo(x, y, x + BAR_RADIUS, y, BAR_RADIUS)
  //     ctx.closePath()
  //     ctx.fillStyle = fillStyle
  //     ctx.fill()
  //   })
  // }, [wave, seekValue])

  const theme = useTheme()
  if (!wave) return null

  return (
    // @ts-ignore
    // <div ref={ref}>
    //   <canvas
    //     ref={canvasRef}
    //     style={{
    //       width: '100%',
    //       height: '28px',
    //     }}
    //   />
    // </div>

    <Container
      // @ts-ignore
      ref={ref}
      sx={sx}
    >
      {wave.map((barValue, index) => {
        const heightPercentage = Math.round((barValue / 128) * 100)
        const seekPassed = index / wave.length < seekValue

        return (
          <Wave
            key={index}
            sx={{
              height: `${heightPercentage}%`,
              backgroundColor: seekPassed
                ? variant === 'message'
                  ? theme.palette.secondary.main
                  : theme.palette.primary500
                : variant === 'message'
                  ? theme.palette.lightGray
                  : theme.palette.neutral300,
            }}
          />
        )
      })}
    </Container>
  )
})

const Container = styled('div')`
  display: flex;
  width: 100%;
  height: 28px;
  direction: ltr;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`

const Wave = styled('div')`
  width: 2px;
  border-radius: 20px;
`
